import qs from 'qs';
import { Alert, AlertType, CustomRule, Rule, Status } from 'src/types/alert';
import { StrapiResponse } from 'src/types/http';

import { api } from '../../api/api';

export type CreateAlert = {
  favorite: number;
  type: AlertType;
  status: Status;
  rule: Rule | CustomRule<string>;
};

export type UpdateAlert = {
  id: number;
  status: Status;
};

export const createAlert = async (newAlert: CreateAlert) => {
  const { data } = await api.post<StrapiResponse<Alert>>('/alerts', newAlert);
  return data;
};

export const updateAlert = async (alertId: number, status: Status) => {
  const { data } = await api.put<StrapiResponse<Alert>>(`/alerts/${alertId}`, {
    status,
  });
  return data;
};

export const getAlertsByFavoriteId = async (favoriteId: number) => {
  const query = qs.stringify({
    filters: {
      favorite: {
        id: favoriteId,
      },
    },
  });
  const { data } = await api.get<StrapiResponse<Alert[]>>(`/alerts?${query}`);
  return data;
};

export const updateBatchAlertStatus = async (
  alertsToCreate: CreateAlert[],
  alertsToUpdate: UpdateAlert[],
) => {
  const { data } = await api.post('/alert/update-batch-alert-status', {
    data: {
      alertsToCreate,
      alertsToUpdate,
    },
  });
  return data;
};
